import React, { Component } from 'react'
import { Row, Col, Card, CardBody, Container, Table } from "reactstrap";

//import { campInfoUrl } from "../../helpers/url"

import Breadcrumbs from "../../components/Common/Breadcrumb"

//import campInfoUrl from "../../helpers/url"

export default class Back extends Component {
    constructor(props) {
        super(props);
        this.state={
            breadcrumbItems : [
                { title : "UTJD", link : "/dashboard" },
                { title : "Camp Info", link : "#" },
            ],
            data: [],
            iconsrc: ["ri-book-2-fill", "ri-women-fill", "ri-men-fill", "ri-building-fill", "ri-home-gear-fill", "ri-lock-fill", "ri-map-pin-3-fill"]
        }
    }

    componentDidMount() {
        const jwt = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = jwt.jwtToken
        const URI = process.env.REACT_APP_API + "stats";
        fetch(URI, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        })
        .then(res=>res.json())
        .then((data) => {
            this.setState({
                data: data
            })
        })
    }
    
    
    render() {
        console.log(this.state.data)
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="Stats" breadcrumbItems={this.state.breadcrumbItems} />

                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardBody>
                                <h4 className="card-title">Stats</h4>
                                    <p className="card-title-desc">Latest stats based on the entries.</p>

                                    <div className="table-rep-plugin">
                                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                                            <Table id="tech-companies-1" striped bordered responsive>
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th data-priority="1">Description</th>
                                                        <th data-priority="3">Value</th>
                                                        <th data-priority="1">Info</th>
                                                        <th data-priority="3">Created</th>
                                                        <th data-priority="3">Last Updated</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    { this.state.data.length > 1 ?
                                                    this.state?.data.map((content, i) => 
                                                        content.disable ? "" :
                                                        <tr>
                                                            <td>{content.id}</td>
                                                            <td><i className={this.state.iconsrc[i]}> </i>{content.description}</td>
                                                            <td>{content.value}</td>
                                                            <td>{content.info}</td>
                                                            <td>{new Date(content.created).toLocaleString('no-EU')}</td>
                                                            <td>{new Date(content.lastUpdated).toLocaleString('no-EU')}</td>
                                                        </tr>
                                                    ) : "Token Has Expired, Please Re-Login!"
                                                }
                                                </tbody>
                                                </Table>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
            
        )
    }
}
